import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ClockIcon, ArrowRightIcon } from '@heroicons/react/24/solid';

const FFSlide04Status: React.FC = () => {
  const completed = [
    'Complete mastery system architecture (680 modules)',
    'Dynamic module loading infrastructure',
    'Gamification engine (XP, streaks, rewards)',
    'School consultation and requirements gathering',
    'Cranbrook whole of year 8 onboarded for pilot',
    'AI content generation pipeline',
    'Teacher classroom management system',
    'Baseline testing system',
  ];

  const inProgress = [
    'Year 8 content modules',
    'Parent dashboard with activity feed',
    'PLC and Shore consultation ongoing',
    'UK engagement with Wellington College',
    'Capital raise',
  ];

  const next = [
    'Complete pilot with Cranbrook',
    'Tune mastery decay parameters with real data',
    'Dual currency reward system',
    'Enable single user sign up for B2C',
    'Expand content',
    'Build sales pipeline',
    'Activate B2C go to market strategy',
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-3 text-center"
      >
        Current Status
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-10 text-center"
      >
        MVP built on bootstrap budget — ready for trial
      </motion.p>

      <div className="flex gap-6 w-full max-w-6xl">
        {/* Completed */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex-1"
        >
          <h3 className="text-lg font-semibold text-[#10b981] mb-4 flex items-center gap-2">
            <CheckCircleIcon className="w-6 h-6" />
            Completed
          </h3>
          <div
            className="p-5 rounded-xl h-[calc(100%-2rem)]"
            style={{
              background: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.3)',
            }}
          >
            <div className="space-y-2">
              {completed.map((item, idx) => (
                <div key={idx} className="flex items-start gap-2">
                  <CheckCircleIcon className="w-4 h-4 text-[#10b981] mt-1 flex-shrink-0" />
                  <span className="text-sm text-[#94a3b8]">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* In Progress */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="flex-1"
        >
          <h3 className="text-lg font-semibold text-[#f59e0b] mb-4 flex items-center gap-2">
            <ClockIcon className="w-6 h-6" />
            In Progress
          </h3>
          <div
            className="p-5 rounded-xl"
            style={{
              background: 'rgba(245, 158, 11, 0.1)',
              border: '1px solid rgba(245, 158, 11, 0.3)',
            }}
          >
            <div className="space-y-3">
              {inProgress.map((item, idx) => (
                <div key={idx} className="flex items-start gap-2">
                  <div className="w-4 h-4 rounded-full border-2 border-[#f59e0b] mt-1 flex-shrink-0 animate-pulse" />
                  <span className="text-sm text-[#94a3b8]">{item}</span>
                </div>
              ))}
            </div>

            <div
              className="mt-6 p-4 rounded-lg text-center"
              style={{ background: 'rgba(245, 158, 11, 0.15)' }}
            >
              <p className="text-white font-medium">
                Pilot school: <span className="text-[#f59e0b]">Cranbrook</span>
              </p>
              <p className="text-sm text-[#94a3b8] mt-1">Year 8 Maths</p>
            </div>
          </div>
        </motion.div>

        {/* Next Steps */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex-1"
        >
          <h3 className="text-lg font-semibold text-[#0ea5e9] mb-4 flex items-center gap-2">
            <ArrowRightIcon className="w-6 h-6" />
            Next Steps
          </h3>
          <div
            className="p-5 rounded-xl"
            style={{
              background: 'rgba(14, 165, 233, 0.1)',
              border: '1px solid rgba(14, 165, 233, 0.3)',
            }}
          >
            <div className="space-y-3">
              {next.map((item, idx) => (
                <div key={idx} className="flex items-start gap-2">
                  <div className="w-4 h-4 rounded border border-[#0ea5e9] mt-1 flex-shrink-0" />
                  <span className="text-sm text-[#94a3b8]">{item}</span>
                </div>
              ))}
            </div>

            <div
              className="mt-6 p-4 rounded-lg"
              style={{ background: 'rgba(14, 165, 233, 0.15)' }}
            >
              <p className="text-sm text-[#94a3b8]">
                <span className="text-white font-medium">Key milestone:</span> Achieve $1M ARR to trigger next capital raise.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FFSlide04Status;
